<template>
  <div class="main">
    <div class="header">
      <div class="flex">
        <div class="user">
          <div class="userIcon"></div>
          <div>
            <div>{{ userInfo.name }}</div>
          </div>
        </div>
        <div @click="goOut">{{ $t('退出') }}</div>
      </div>
    </div>
    <!-- 邀请信息 -->

    <div class="invite-info">
      <div>
        <div>{{ $t('主体') }}</div>
        <div>{{ userInfo.name }}</div>
      </div>

      <div>
        <div>{{ $t('产品购买合同') }}</div>
        <div>{{ contractId }}</div>
      </div>

      <div>
        <div>{{ $t('商务代表') }}</div>
        <div>{{ creatorName }}</div>
      </div>

      <div>
        <div>{{ $t('联系电话') }}</div>
        <div>{{ telphoneNo }}</div>
      </div>
    </div>
    <!-- 订单信息 -->

    <div class="order-info">
      <div v-for="(item, index) in invitationOrder" :key="index" class="order-item">
        <div>
          <span>{{ $t('订单ID') }}&nbsp;{{ item.showId }}</span>
          <span @click="item.showDetail = !item.showDetail">
            <i class="arrow-up" v-if="item.showDetail"></i>
            <i class="arrow-down" v-else></i>
          </span>
        </div>
        <div v-show="item.showDetail">
          <ul>
            <li>
              <div>{{ $t('商品名称') }}</div>
              <div>{{ item.commodityName }}</div>
            </li>
            <li>
              <div>{{ $t('订单规格（份）') }}</div>
              <div>
                <span v-if="item.isUnLimitNum">{{ $t('无限') }}</span>
                <span v-else>{{ getShowPrice(item, 'totalNum', 'G') }} {{ getShowUnit(item) }}</span>
                <span v-show="item.paymentType === 3">{{ $t('（按量后付）') }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('有效期') }}</div>
              <div>
                {{
                  item.productType == 2
                    ? '--'
                    : item.isUnLimitTime
                    ? $t('无限')
                    : item.effectiveDate + fomrateffectiveUnit[item.effectiveUnit]
                }}
              </div>
            </li>
            <li>
              <div>{{ $t('订单成交总金额（元）') }}</div>
              <div>
                <span>{{ item.price }}</span>
                <span v-show="item.paymentType === 3">{{ $t('（已出账）') }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('已付款金额（元）') }}</div>
              <div>
                <span>{{ item.amountPaid }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('本次应支付金额（元）') }}</div>
              <div>{{ item.shoudPay }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 协议 -->

    <div class="pdf-info">
      <es-checkbox v-model="checked"></es-checkbox>{{ $t('我已阅读并同意')
      }}<span @click="jumpToPdf">{{ $t('《e签宝产品购买协议》') }}</span>
    </div>

    <div class="footer">
      <h5Footer :invitationPrice="invitationPrice" :text="$t(`确认购买信息`)" @click="goNext()"></h5Footer>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { MessageBox } from 'mint-ui'
import 'mint-ui/lib/message-box/style.css'
import mixins from '../common'
export default {
  mixins: [mixins],
  components: {
    h5Footer: () => import('./components/footer'),
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      checked: false,
      contractId: '',
      creatorName: '',
      invitationPrice: '',
      invitationOrder: [],
      telphoneNo: '',
    }
  },
  methods: {
    // 下一步
    goNext() {
      if (!this.checked) {
        return
      }
      this.$router.push({
        path: '/invitePaymentH5/pay',
        query: {
          invitationId: this.$route.query.invitationId,
          invitationPrice: this.invitationPrice,
        },
      })
    },
    goOut() {
      this.$ajax(this.$url.logout(), {}).then(() => {
        this.$ajax(this.$url.getInfo(), {})
      })
    },
    // 已经打开过邀约支付链接
    getMarkOpened() {
      this.$ajax(this.$url.getMarkOpened(this.$route.query.invitationId), {})
    },
    jumpToPdf() {
      this.$router.push({
        path: '/invitePaymentH5/pdf',
        query: {
          contractId: this.contractId,
        },
      })
    },
    getInfo() {
      this.$ajax(this.$url.getPayInvitations(this.$route.query.invitationId), {}, false)
        .then((res) => {
          this.getMarkOpened()
          this.invitationOrder = res.data.invitationOrder || []
          this.invitationOrder.forEach((item) => {
            this.$set(item, 'showDetail', false)
          })
          this.telphoneNo = res.data.telphoneNo
          this.invitationPrice = res.data.invitationPrice
          this.creatorName = res.data.creatorName
          this.contractId = res.data.contractId
        })
        .catch((err) => {
          MessageBox.alert(err.message).then((action) => {
            window.location.href = 'https://www.esign.cn/'
          })
        })
    },
    reload() {
      const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/
      if (browserRule.test(navigator.userAgent)) {
        window.onpageshow = function (event) {
          if (event.persisted) {
            window.location.reload()
          }
        }
      }
    },
  },
  mounted() {
    this.reload()
    this.getInfo()
  },
}
</script>
<style lang="less" scoped>
.main {
  background: #f2f5f7;
  min-height: 100%;
}
.header {
  height: 236px;
  width: 100%;
  background: url('../../../assets/common/banner.png') no-repeat;
  background-size: 100% 100%;
}
.userIcon {
  padding-left: 24px;
  height: 24px;
  background: url('../../../assets/icons/me.png') no-repeat;
  background-size: 100% 100%;
}
.flex {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  color: #fff;
  > .user {
    display: flex;
    align-items: center;
    > .userIcon {
      margin-right: 10px;
    }
  }
}
.invite-info {
  background: #ffffff;
  > div {
    height: 50px;
    line-height: 50px;
    padding: 0 24px;
    color: #000;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e1e3e6;
    > div:first-child {
      color: #4d4d4d;
    }
  }
  > div:last-child {
    border-bottom: 0;
  }
}
.order-info {
  margin-top: 15px;
  background: #fff;
}
.order-item {
  padding: 0 24px;
  border-bottom: 1px solid #d8d8d8;
  > div:first-child {
    color: #383838;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
  }
  ul {
    padding-bottom: 10px;
  }
  li {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    > div:first-child {
      color: #4d4d4d;
    }
  }
}
.pdf-info {
  line-height: 90px;
  text-align: center;
  padding-bottom: 60px;
  span {
    margin-left: 2px;
    color: #999999;
    font-size: 12px;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
}
.arrow-up {
  background-image: url('../../../assets/icons/up.png');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
.arrow-down {
  background-image: url('../../../assets/icons/down.png');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
</style>
